import * as React from 'react';

import * as styles from './styles.css';

export const Filters: React.FC<React.PropsWithChildren> = props => {
  return (
    <div className={styles['container']} data-testid="offers_history_filters">
      {props.children}
    </div>
  );
};
